import BaseCtrl from 'edge/platform/base/BaseCtrl';
import _ from 'lodash';

import styles from 'edge/faq/directives/FaqDirective-hashed.scss';

var fn = function fn($scope, $location, $anchorScroll, FaqService, TranslateService, $stateParams) {
    var ctrl = Object.create(BaseCtrl);

    function translateContent(sectionsData) {
        sectionsData.forEach(function (section) {
            TranslateService.translate({
                object: section,
                propName: 'title',
                displayKey: section.title,
                scope: $scope
            });

            section.topics.forEach(function (topic) {
                TranslateService.translate({
                    object: topic,
                    propName: 'question',
                    displayKey: topic.question,
                    scope: $scope
                });

                TranslateService.translate({
                    object: topic,
                    propName: 'long',
                    displayKey: topic.long,
                    scope: $scope
                });

                if (topic.link && topic.link.name) {
                    TranslateService.translate({
                        object: topic.link,
                        propName: 'name',
                        displayKey: topic.link.name,
                        scope: $scope
                    });
                }
            });
        });

        return sectionsData;
    }

    function isSectionVisible(section, query) {
        var filter = query || $scope.search.query;
        var result = null;

        if (filter) {
            result = section.topics.some(function (topic) {
                return topicSearch(filter)(topic);
            });
        } else {
            result = section.topics.length > 0;
        }

        return result;
    }

    function sectionSearch(query) {
        return function (section) {
            return isSectionVisible(section, query);
        };
    }

    function topicSearch(query) {
        return function (topic) {
            if (!query) {
                return true;
            }

            var questionMatching = checkSafeMatching(topic.question, query);
            var answerMatching = checkSafeMatching(topic.long, query);
            var linkMatching = topic.link && topic.link.name ? checkSafeMatching(topic.link.name, query) : false;
            return questionMatching || answerMatching || linkMatching;
        };
    }

    function checkSafeMatching(phrase, query) {
        var htmlStrippedPhrase = _.unescape(phrase.replace(/<[^<>]+>/gi, ''));
        return htmlStrippedPhrase.toLocaleLowerCase().includes(query.toLowerCase());
    }

    function isTopicOpened(topicId) {
        return topicId === $location.hash();
    }

    ctrl.init = function () {
        if ($stateParams.faqScrollTo) {
            $location.hash($stateParams.faqScrollTo);
            $anchorScroll();
        }

        var faqSections = FaqService.getAllSections();
        $scope = Object.assign($scope, {
            search: {},
            sections: translateContent(faqSections),
            sectionSearch: sectionSearch,
            topicSearch: topicSearch,
            isTopicOpened: isTopicOpened,
            isSectionVisible: isSectionVisible,
            styles: styles
        });
    };

    ctrl.selectSection = function (sectionId) {
        $location.hash(sectionId);
        $anchorScroll();
    };

    return ctrl.create($scope, $location, $anchorScroll, FaqService, TranslateService);
};

fn.$inject = ['$scope', '$location', '$anchorScroll', 'FaqService', 'TranslateService', '$stateParams'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/faq/controllers/FaqCtrl.js
// module id = 949
// module chunks = 0